module.exports = __webpack_public_path__ + "media/svg-new/next-level-b991fe5e.svg";